import { render, staticRenderFns } from "./_ambassador.vue?vue&type=template&id=eac2c708&lang=pug&"
import script from "./_ambassador.vue?vue&type=script&lang=js&"
export * from "./_ambassador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports